import InventoryNearYou from './components/InventoryNearYou';

const InventoryNearYouRoot = () => (
  <div className="container pb-30 2xl:pb-10 relative">
    <InventoryNearYou />
  </div>
);

export default InventoryNearYouRoot;
